import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Eye, EyeOff } from 'lucide-react';

interface PasswordInputProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  isInvalid?: boolean;
  feedback?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  label = 'Password',
  value,
  onChange,
  placeholder = 'Enter your password',
  isInvalid = false,
  feedback
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleVisibility = () => setShowPassword(prev => !prev);

  return (
    <Form.Group controlId="passwordInput">
      <Form.Label>{label}</Form.Label>
      <InputGroup>
        <Form.Control
          type={showPassword ? 'text' : 'password'}
          autoComplete="off"
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          isInvalid={isInvalid}
        />
        <InputGroup.Text
          onClick={toggleVisibility}
          style={{ cursor: 'pointer', backgroundColor: 'transparent', border: 'none' }}
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </InputGroup.Text>
        {isInvalid && feedback && (
          <Form.Control.Feedback type="invalid">{feedback}</Form.Control.Feedback>
        )}
      </InputGroup>
    </Form.Group>
  );
};

export default PasswordInput;